import React, { useState } from 'react';
import InputRange from 'react-input-range';

import css from './InputSlider.module.scss';

interface Props {
    onChange: (value: number) => void;
    onChangeComplete: (value: number) => void;
    options: {
        min: number;
        max: number;
        step: number;
        value: number;
    };
}

const InputSlider: React.FC<Props> = ({ onChange, onChangeComplete, options }) => {
    const [innerOptions, setInnerOptions] = useState(options);

    const handleChange = (value: number) => {
        setInnerOptions({ ...innerOptions, value });
        onChange(value);
    };

    return (
        <div className={css.container}>
            <InputRange
                minValue={innerOptions.min}
                maxValue={innerOptions.max}
                step={innerOptions.step}
                classNames={{
                    activeTrack: css.activeTrack,
                    disabledInputRange: '',
                    inputRange: css.range,
                    labelContainer: css.labelContainer,
                    maxLabel: css.hidden,
                    minLabel: css.hidden,
                    slider: css.sliderButton,
                    sliderContainer: '',
                    track: css.track,
                    valueLabel: css.hidden,
                }}
                onChangeComplete={(value) => {
                    if (typeof value !== 'number') {
                        throw new Error('Error: input slider value is not a number');
                    }

                    onChangeComplete(value);
                }}
                onChange={(value) => {
                    if (typeof value !== 'number') {
                        throw new Error('Error: input slider value is not a number');
                    }

                    handleChange(value);
                }}
                value={innerOptions.value}
            />
        </div>
    );
};

export default React.memo(InputSlider);
